// extracted by mini-css-extract-plugin
export default {"container":"Wq-z","heading":"Xq-z","text":"Yq-z","info":"Zq-z","link":"_q-z","fullMaxWidth":"ar-z"};